import { ClientGlobalRoleAssignmentRoleEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useAppState } from '@/features/authorization/provider/useAppState';

/**
 * Global roles ordered by permission breadth, highest first. `SUPER_ADMIN` is
 * the broadest platform role, `ORGANIZATION_CONFIGURATION_ADMIN` the narrowest.
 */
export const GLOBAL_ROLE_PRIORITY: ClientGlobalRoleAssignmentRoleEnum[] = [
  ClientGlobalRoleAssignmentRoleEnum.SuperAdmin,
  ClientGlobalRoleAssignmentRoleEnum.GlobalConfigurationAdmin,
  ClientGlobalRoleAssignmentRoleEnum.OrganizationConfigurationAdmin
];

/**
 * Returns the highest-priority global role the current user holds (by
 * {@link GLOBAL_ROLE_PRIORITY}), or `undefined` if the user has no global role.
 *
 * Use this whenever a single global role has to be surfaced (e.g. a role label),
 * so the choice is deterministic instead of picking an arbitrary assignment.
 */
export const useHighestGlobalRole = ():
  ClientGlobalRoleAssignmentRoleEnum | undefined => {
  const { globalRoles } = useAppState();
  const heldRoles = new Set(globalRoles.map((assignment) => assignment.role));
  return GLOBAL_ROLE_PRIORITY.find((role) => heldRoles.has(role));
};
